import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type AvailableAddOnPlansQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AvailableAddOnPlansQuery = {
  __typename?: 'Query';
  availableAddOnPlans: Array<{
    __typename?: 'SubscriptionAddOnPlan';
    id: string;
    name: string;
    displayName: string;
    description: string;
    amount: number;
    currency: string;
    interval: Types.SubscriptionInterval;
    selectable: boolean;
    current: boolean;
    features: Array<{
      __typename?: 'AddOnFeature';
      type: string;
      value: string;
      valueType: Types.AddOnFeatureValueType;
    }>;
  }>;
};

export type PreviewAddOnPurchaseQueryVariables = Types.Exact<{
  inputs: Types.PreviewAddOnPurchaseInputs;
}>;

export type PreviewAddOnPurchaseQuery = {
  __typename?: 'Query';
  previewAddOnPurchase: {
    __typename?: 'AddOnPurchasePreview';
    amountDue: number;
    tax?: number | null;
    nextBillingAmount: number;
    nextBillingDate: number;
    prorationDate: number;
  };
};

export type PurchaseAddOnMutationVariables = Types.Exact<{
  inputs: Types.PurchaseAddOnInputs;
}>;

export type PurchaseAddOnMutation = {
  __typename?: 'Mutation';
  purchaseAddOn: {
    __typename?: 'PurchaseAddOnMutationResponse';
    code: string;
    success: boolean;
    message: string;
    subscription?: {
      __typename?: 'UserSubscription';
      addOns: Array<{
        __typename?: 'SubscriptionAddOn';
        id: string;
        plan: {
          __typename?: 'SubscriptionAddOnPlan';
          id: string;
          displayName: string;
          interval: Types.SubscriptionInterval;
        };
      }>;
    } | null;
  };
};

export type CancelAddOnMutationVariables = Types.Exact<{
  inputs: Types.CancelAddOnInputs;
}>;

export type CancelAddOnMutation = {
  __typename?: 'Mutation';
  cancelAddOn: {
    __typename?: 'CancelAddOnMutationResponse';
    code: string;
    success: boolean;
    message: string;
    subscription?: {
      __typename?: 'UserSubscription';
      addOns: Array<{
        __typename?: 'SubscriptionAddOn';
        id: string;
        endsAt?: number | null;
        plan: {
          __typename?: 'SubscriptionAddOnPlan';
          id: string;
          displayName: string;
          interval: Types.SubscriptionInterval;
        };
      }>;
    } | null;
  };
};

export type UndoCancelAddOnMutationVariables = Types.Exact<{
  inputs: Types.UndoCancelAddOnInputs;
}>;

export type UndoCancelAddOnMutation = {
  __typename?: 'Mutation';
  undoCancelAddOn: {
    __typename?: 'UndoCancelAddOnMutationResponse';
    code: string;
    success: boolean;
    message: string;
    subscription?: {
      __typename?: 'UserSubscription';
      addOns: Array<{
        __typename?: 'SubscriptionAddOn';
        id: string;
        endsAt?: number | null;
        plan: {
          __typename?: 'SubscriptionAddOnPlan';
          id: string;
          displayName: string;
          interval: Types.SubscriptionInterval;
        };
      }>;
    } | null;
  };
};

export const AvailableAddOnPlansQueryDocument = gql`
  query availableAddOnPlansQuery {
    availableAddOnPlans {
      id
      name
      displayName
      description
      amount
      currency
      interval
      selectable
      current
      features {
        type
        value
        valueType
      }
    }
  }
`;

/**
 * __useAvailableAddOnPlansQuery__
 *
 * To run a query within a React component, call `useAvailableAddOnPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAddOnPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAddOnPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableAddOnPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableAddOnPlansQuery,
    AvailableAddOnPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AvailableAddOnPlansQuery, AvailableAddOnPlansQueryVariables>(
    AvailableAddOnPlansQueryDocument,
    options
  );
}
export function useAvailableAddOnPlansQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableAddOnPlansQuery,
    AvailableAddOnPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AvailableAddOnPlansQuery, AvailableAddOnPlansQueryVariables>(
    AvailableAddOnPlansQueryDocument,
    options
  );
}
export type AvailableAddOnPlansQueryHookResult = ReturnType<
  typeof useAvailableAddOnPlansQuery
>;
export type AvailableAddOnPlansQueryLazyQueryHookResult = ReturnType<
  typeof useAvailableAddOnPlansQueryLazyQuery
>;
export type AvailableAddOnPlansQueryQueryResult = Apollo.QueryResult<
  AvailableAddOnPlansQuery,
  AvailableAddOnPlansQueryVariables
>;
export const PreviewAddOnPurchaseQueryDocument = gql`
  query previewAddOnPurchaseQuery($inputs: PreviewAddOnPurchaseInputs!) {
    previewAddOnPurchase(inputs: $inputs) {
      amountDue
      tax
      nextBillingAmount
      nextBillingDate
      prorationDate
    }
  }
`;

/**
 * __usePreviewAddOnPurchaseQuery__
 *
 * To run a query within a React component, call `usePreviewAddOnPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewAddOnPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewAddOnPurchaseQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function usePreviewAddOnPurchaseQuery(
  baseOptions: Apollo.QueryHookOptions<
    PreviewAddOnPurchaseQuery,
    PreviewAddOnPurchaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PreviewAddOnPurchaseQuery, PreviewAddOnPurchaseQueryVariables>(
    PreviewAddOnPurchaseQueryDocument,
    options
  );
}
export function usePreviewAddOnPurchaseQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PreviewAddOnPurchaseQuery,
    PreviewAddOnPurchaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PreviewAddOnPurchaseQuery,
    PreviewAddOnPurchaseQueryVariables
  >(PreviewAddOnPurchaseQueryDocument, options);
}
export type PreviewAddOnPurchaseQueryHookResult = ReturnType<
  typeof usePreviewAddOnPurchaseQuery
>;
export type PreviewAddOnPurchaseQueryLazyQueryHookResult = ReturnType<
  typeof usePreviewAddOnPurchaseQueryLazyQuery
>;
export type PreviewAddOnPurchaseQueryQueryResult = Apollo.QueryResult<
  PreviewAddOnPurchaseQuery,
  PreviewAddOnPurchaseQueryVariables
>;
export const PurchaseAddOnMutationDocument = gql`
  mutation purchaseAddOnMutation($inputs: PurchaseAddOnInputs!) {
    purchaseAddOn(inputs: $inputs) {
      code
      success
      message
      subscription {
        addOns {
          id
          plan {
            id
            displayName
            interval
          }
        }
      }
    }
  }
`;
export type PurchaseAddOnMutationMutationFn = Apollo.MutationFunction<
  PurchaseAddOnMutation,
  PurchaseAddOnMutationVariables
>;

/**
 * __usePurchaseAddOnMutation__
 *
 * To run a mutation, you first call `usePurchaseAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseAddOnMutation, { data, loading, error }] = usePurchaseAddOnMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function usePurchaseAddOnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PurchaseAddOnMutation,
    PurchaseAddOnMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PurchaseAddOnMutation, PurchaseAddOnMutationVariables>(
    PurchaseAddOnMutationDocument,
    options
  );
}
export type PurchaseAddOnMutationHookResult = ReturnType<typeof usePurchaseAddOnMutation>;
export type PurchaseAddOnMutationMutationResult =
  Apollo.MutationResult<PurchaseAddOnMutation>;
export type PurchaseAddOnMutationMutationOptions = Apollo.BaseMutationOptions<
  PurchaseAddOnMutation,
  PurchaseAddOnMutationVariables
>;
export const CancelAddOnMutationDocument = gql`
  mutation cancelAddOnMutation($inputs: CancelAddOnInputs!) {
    cancelAddOn(inputs: $inputs) {
      code
      success
      message
      subscription {
        addOns {
          id
          endsAt
          plan {
            id
            displayName
            interval
          }
        }
      }
    }
  }
`;
export type CancelAddOnMutationMutationFn = Apollo.MutationFunction<
  CancelAddOnMutation,
  CancelAddOnMutationVariables
>;

/**
 * __useCancelAddOnMutation__
 *
 * To run a mutation, you first call `useCancelAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAddOnMutation, { data, loading, error }] = useCancelAddOnMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCancelAddOnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelAddOnMutation,
    CancelAddOnMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelAddOnMutation, CancelAddOnMutationVariables>(
    CancelAddOnMutationDocument,
    options
  );
}
export type CancelAddOnMutationHookResult = ReturnType<typeof useCancelAddOnMutation>;
export type CancelAddOnMutationMutationResult =
  Apollo.MutationResult<CancelAddOnMutation>;
export type CancelAddOnMutationMutationOptions = Apollo.BaseMutationOptions<
  CancelAddOnMutation,
  CancelAddOnMutationVariables
>;
export const UndoCancelAddOnMutationDocument = gql`
  mutation undoCancelAddOnMutation($inputs: UndoCancelAddOnInputs!) {
    undoCancelAddOn(inputs: $inputs) {
      code
      success
      message
      subscription {
        addOns {
          id
          endsAt
          plan {
            id
            displayName
            interval
          }
        }
      }
    }
  }
`;
export type UndoCancelAddOnMutationMutationFn = Apollo.MutationFunction<
  UndoCancelAddOnMutation,
  UndoCancelAddOnMutationVariables
>;

/**
 * __useUndoCancelAddOnMutation__
 *
 * To run a mutation, you first call `useUndoCancelAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoCancelAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoCancelAddOnMutation, { data, loading, error }] = useUndoCancelAddOnMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUndoCancelAddOnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UndoCancelAddOnMutation,
    UndoCancelAddOnMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UndoCancelAddOnMutation, UndoCancelAddOnMutationVariables>(
    UndoCancelAddOnMutationDocument,
    options
  );
}
export type UndoCancelAddOnMutationHookResult = ReturnType<
  typeof useUndoCancelAddOnMutation
>;
export type UndoCancelAddOnMutationMutationResult =
  Apollo.MutationResult<UndoCancelAddOnMutation>;
export type UndoCancelAddOnMutationMutationOptions = Apollo.BaseMutationOptions<
  UndoCancelAddOnMutation,
  UndoCancelAddOnMutationVariables
>;
